// The self-test's line on the machine panel's Check tab (EventCheck.vue): what it is
// doing or how it ended. Cancelled is neither passed nor failed, unless
// only its memory test was (the rest measured: passed, selftest.go).
import type { SelfTest } from './api'

export type SelfTestVerdict = 'running' | 'cancelling' | 'passed' | 'failed' | 'cancelled'

export function selfTestVerdict(t: SelfTest): SelfTestVerdict {
    if (t.running) return t.cancelled ? 'cancelling' : 'running'
    if (t.passed) return 'passed'
    return t.cancelled && !t.steps.some((s) => s.state === 'fail') ? 'cancelled' : 'failed'
}
